/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import MyBox from '../containers/my/MyBox';
import MyPay from '../containers/my/MyPay';

import MyWrite from '../containers/my/MyWrite';
import MyFriend from '../containers/my/MyFriend';
import MyNoti from '../containers/my/MyNoti';

import MyCoupon from '../containers/my/MyCoupon';

import Footer from '../components/Footer';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class MyPage extends PureComponent {
  state = {
    menu: 0,
  };
  componentDidMount = () => {
    const { match } = this.props;
    let menu = match.params.menu;
    ////console.log(match)
    //console.log(index)
    if (menu === '' || menu === null || menu === undefined) {
      menu = 0;
    }

    setTimeout(() => {
      this.setState({
        menu: parseInt(menu),
      });
    }, 500);

    this._getData();
  };
  _getData = async () => {
    const { history } = this.props;
    const result = await this._getDataApi();

    if (result) {
      const intReturn = result.data[0].intReturn;
      const data = result.data[0].listData;

      if (intReturn === 0) {
        this.setState({
          data,
        });
      } else {
        history.push('/');
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _getDataApi = () => {
    const { apiUrl, loginId, pkg, history } = this.props;
    const at = this.getCookie('at');

    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/my_pkg',
        {
          params: {
            userid: loginId,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
        //console.log('error...')
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      this.setCookie('at', data[0].at);
      // localStorage.setItem('at', data[0].at);
      this._getData();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _myMenu = (menu) => {
    //alert(menu)
    window.scrollTo(0, 0);
    this.setState({
      menu,
    });
  };
  _regCashCard = () => {
    const { loginId, setCardRegShow } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      setCardRegShow(true);
    }
  };
  _onCardList = () => {
    const { setCardListShow } = this.props;
    setCardListShow(true);
  };
  _setting = () => {
    const { setSettingShow } = this.props;
    setSettingShow(true);
  };
  _friendAdd = () => {
    const { setShowFriend } = this.props;

    setShowFriend(true);
  };
  _memberEdit = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);
    history.push('/edit');
  };
  _coupon = () => {
    //toast.warn('준비중입니다.')
    window.scrollTo(0, 0);
    this._myMenu(12);
  };
  _profile = () => {
    const { history } = this.props;
    window.scrollTo(0, 0);
    history.push('/profile');
  };
  _myShop = () => {
    window.open('https://shop.aniplustv.com/mypage', '', '');
  };
  render() {
    const { data, menu } = this.state;
    const { icon, imgUrl } = this.props;
    return (
      <Fragment>
        <div className="content">
          {/*<!-- my page/ -->*/}
          <div className="my_wrap">
            <div className="my_head">
              <div className="profile">
                <button type="button" className="set" onClick={this._setting}>
                  설정
                </button>
                <div className="img">
                  <img src={icon} />
                </div>
              </div>
              <div className="memberArea">
                <p className="name">{data ? data[0].nicName : ''}님</p>
                <p className="membership">
                  {data
                    ? data[0].endDate === ''
                      ? '보유 멤버십 없음'
                      : data[0].autoFlag === 'Y'
                      ? '정기결제 이용중'
                      : '멤버십 이용중'
                    : null}
                  <span className="date">
                    {data
                      ? data[0].endDate !== ''
                        ? '(~' + data[0].endDate + ')'
                        : null
                      : null}
                  </span>
                </p>
                <p className="link">
                  <a onClick={this._memberEdit} style={{ cursor: 'pointer' }}>
                    회원정보수정
                  </a>
                  <a onClick={this._profile} style={{ cursor: 'pointer' }}>
                    프로필 변경
                  </a>
                  {/* <a onClick={this._coupon} style={{ cursor: 'pointer' }}>
                    나의쿠폰
                  </a> */}
                  <a onClick={this._myShop}>
                    나의쇼핑<span></span>
                  </a>
                </p>
              </div>
              <div className="infoArea">
                <div className="info">
                  {/* <dl>
                    <dt>
                      <a
                        onClick={() => this._myMenu(8)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={imgUrl + '/img/mypage/ico_usres.png'} />
                        <p>내친구</p>
                      </a>
                    </dt>
                    <dd>
                      <a
                        onClick={() => this._myMenu(8)}
                        style={{ cursor: 'pointer' }}
                      >
                        {data ? data[0].frined : 0} 명
                      </a>
                    </dd>
                  </dl> */}
                  <dl>
                    <dt>
                      <a
                        onClick={this._onCardList}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={imgUrl + '/img/mypage/ico_cash.png'} />
                        <p>보유포인트</p>
                      </a>
                    </dt>
                    <dd>
                      <a
                        onClick={this._onCardList}
                        style={{ cursor: 'pointer' }}
                      >
                        {data ? this.CommaFormatted(data[0].cash) : 0}
                        {isMobile ? 'P' : '포인트'}
                      </a>
                    </dd>
                  </dl>
                  <dl>
                    <dt>
                      <a
                        onClick={this._onCardList}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={imgUrl + '/img/mypage/ico_card.png'} />
                        <p>내카드</p>
                      </a>
                    </dt>
                    <dd>
                      <a
                        onClick={this._onCardList}
                        style={{ cursor: 'pointer' }}
                      >
                        {data ? data[0].card : 0}개
                      </a>
                    </dd>
                  </dl>
                  {/* <dl>
                    <dt>
                      <a
                        onClick={() => this._myMenu(10)}
                        style={{ cursor: 'pointer' }}
                      >
                        <img src={imgUrl + '/img/mypage/ico_bell.png'} />
                        <p>예약알림</p>
                      </a>
                    </dt>
                    <dd>
                      <a
                        onClick={() => this._myMenu(10)}
                        style={{ cursor: 'pointer' }}
                      >
                        {data ? data[0].alram : 0}개
                      </a>
                    </dd>
                  </dl> */}
                </div>
              </div>
            </div>

            <div className="my_body">
              <div className="my_snb">
                {/* <ul>
                  <h3
                    onClick={() => this._myMenu(0)}
                    className={
                      menu === 0 || menu === 1 || menu === 11 ? 'on' : null
                    }
                  >
                    내 보관함
                  </h3>
                  {isMobile ? null : (
                    <>
                      <li>
                        <button
                          type="menu"
                          className={menu === 0 ? 'active' : null}
                          onClick={() => this._myMenu(0)}
                        >
                          나의 찜한 작품
                        </button>
                      </li>
                      <li>
                        <button
                          type="menu"
                          className={menu === 1 ? 'active' : null}
                          onClick={() => this._myMenu(1)}
                        >
                          나의 관람 작품
                        </button>
                      </li>
                      <li>
                        <button
                          type="menu"
                          className={menu === 11 ? 'active' : null}
                          onClick={() => this._myMenu(11)}
                        >
                          다운받은 작품
                        </button>
                      </li>
                    </>
                  )}
                </ul> */}
                <ul>
                  <h3
                    onClick={() => this._myMenu(2)}
                    className={menu === 2 || menu === 3 ? 'on' : null}
                  >
                    나의 결제내역
                  </h3>
                  {isMobile ? null : (
                    <>
                      {/* <li>
                        <button
                          type="menu"
                          className={menu === 2 ? 'active' : null}
                          onClick={() => this._myMenu(2)}
                        >
                          정기결제 내역
                        </button>
                      </li> */}
                      <li>
                        <button
                          type="menu"
                          className={menu === 3 ? 'active' : null}
                          onClick={() => this._myMenu(3)}
                        >
                          포인트 사용 내역
                        </button>
                      </li>
                    </>
                  )}
                </ul>
                <ul>
                  <h3
                    onClick={this._onCardList}
                    className={menu === 4 || menu === 5 ? 'on' : null}
                  >
                    나의 포인트카드
                  </h3>
                  {isMobile ? null : (
                    <>
                      <li>
                        <button
                          type="menu"
                          className={menu === 4 ? 'active' : null}
                          onClick={this._onCardList}
                        >
                          포인트카드 목록
                        </button>
                      </li>
                      <li>
                        <button
                          type="menu"
                          className={menu === 5 ? 'active' : null}
                          onClick={this._regCashCard}
                        >
                          포인트카드 등록
                        </button>
                      </li>
                    </>
                  )}
                </ul>
                <ul>
                  <h3
                    onClick={() => this._myMenu(6)}
                    className={menu === 6 || menu === 7 ? 'on' : null}
                  >
                    내가 쓴 글
                  </h3>
                  {isMobile ? null : (
                    <>
                      <li>
                        <button
                          type="menu"
                          className={menu === 6 ? 'active' : null}
                          onClick={() => this._myMenu(6)}
                        >
                          1:1문의 내역
                        </button>
                      </li>
                      {/* <li>
                        <button
                          type="menu"
                          className={menu === 7 ? 'active' : null}
                          onClick={() => this._myMenu(7)}
                        >
                          내가 작성한 리뷰
                        </button>
                      </li> */}
                    </>
                  )}
                </ul>
                {/* <ul>
                  <h3
                    onClick={() => this._myMenu(8)}
                    className={menu === 8 ? 'on' : null}
                  >
                    내 친구
                  </h3>
                  {isMobile ? null : (
                    <>
                      <li>
                        <button
                          type="menu"
                          className={menu === 8 ? 'active' : null}
                          onClick={() => this._myMenu(8)}
                        >
                          내 친구 현황
                        </button>
                      </li>
                      <li>
                        <button
                          type="menu"
                          className={menu === 9 ? 'active' : null}
                          onClick={this._friendAdd}
                        >
                          친구 추천하기
                        </button>
                      </li>
                    </>
                  )}
                </ul> */}
                {/* <ul>
                  <h3
                    onClick={() => this._myMenu(10)}
                    className={menu === 10 ? 'on' : null}
                  >
                    내 알림
                  </h3>
                  {isMobile ? null : (
                    <li>
                      <button
                        type="menu"
                        className={menu === 10 ? 'active' : null}
                        onClick={() => this._myMenu(10)}
                      >
                        내 본방 알림
                      </button>
                    </li>
                  )}
                </ul> */}
              </div>
              {/*<!-- /my_snb -->*/}
              {menu === 0 || menu === 1 || menu === 11 ? (
                <MyBox index={menu} _myMenu={this._myMenu} />
              ) : menu === 2 || menu === 3 ? (
                <MyPay index={menu} _myMenu={this._myMenu} />
              ) : menu === 4 || menu === 5 ? (
                <MyPay index={menu} _myMenu={this._myMenu} />
              ) : menu === 6 || menu === 7 ? (
                <MyWrite index={menu} _myMenu={this._myMenu} />
              ) : menu === 8 || menu === 9 ? (
                <MyFriend index={menu} _myMenu={this._myMenu} />
              ) : menu === 10 ? (
                <MyNoti index={menu} _myMenu={this._myMenu} />
              ) : menu === 12 ? (
                <MyCoupon index={menu} _myMenu={this._myMenu} />
              ) : null}
            </div>
          </div>
          {/*<!-- /my page-->*/}
        </div>

        <Footer />

        <div className="Toastify"></div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyPage)));
